'use client';

import { c as _c } from "react/compiler-runtime";
import { onrampManifest } from '@morfi/onramp-sdk';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowRight01Icon } from '@/components/ui/icon/glyphs';
export function FundingWalletMethods(t0) {
  const $ = _c(31);
  const {
    connectedWalletEnabled,
    connectedWalletLoading: t1,
    onConnectedWallet,
    cryptoDepositEnabled,
    manualEnabled,
    exchangeEnabled,
    onCryptoDeposit,
    onManualTransfer,
    onExchange
  } = t0;
  const connectedWalletLoading = t1 === undefined ? false : t1;
  const t = useTranslations("onramp");
  const walletPolicy = onrampManifest.onramp.providers.moonpay.methods.wallet_connect;
  const cryptoPolicy = onrampManifest.onramp.providers.moonpay.methods.crypto_deposit;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = walletPolicy.enabled && walletPolicy.surfaces.includes("web");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const walletConfigured = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cryptoPolicy.enabled && cryptoPolicy.surfaces.includes("web");
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const cryptoConfigured = t3;
  let t4;
  if ($[2] !== connectedWalletEnabled || $[3] !== connectedWalletLoading || $[4] !== onConnectedWallet) {
    t4 = walletConfigured && connectedWalletEnabled ? <WalletMethod kind="wallet" enabled={connectedWalletEnabled} loading={connectedWalletLoading} onSelect={onConnectedWallet} /> : null;
    $[2] = connectedWalletEnabled;
    $[3] = connectedWalletLoading;
    $[4] = onConnectedWallet;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== cryptoDepositEnabled || $[7] !== onCryptoDeposit) {
    t5 = cryptoConfigured && cryptoDepositEnabled ? <WalletMethod kind="crypto" enabled={cryptoDepositEnabled} onSelect={onCryptoDeposit} /> : null;
    $[6] = cryptoDepositEnabled;
    $[7] = onCryptoDeposit;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== manualEnabled || $[10] !== onManualTransfer || $[11] !== t) {
    t6 = manualEnabled ? <AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} className="h-auto min-h-16.5 w-full justify-between bg-transparent p-3" onClick={onManualTransfer}><span className="flex items-center gap-3"><OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" priority={true} rounded="" imageClassName="object-contain" src="/assets/onramp/method-manual-transfer.png" alt="" size="size-10" className="bg-transparent" /><span className="flex flex-col items-start"><span className="text-body font-medium">{t("manual_transfer")}</span><span className="text-caption text-foreground-secondary">{t("manual_transfer_subtitle")}</span></span></span></AnimatedButton> : null;
    $[9] = manualEnabled;
    $[10] = onManualTransfer;
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== exchangeEnabled || $[14] !== onExchange || $[15] !== t) {
    t7 = exchangeEnabled && onExchange ? <AnimatedButton variant="tertiary" suffix={ArrowRight01Icon} className="h-auto min-h-16.5 w-full justify-between bg-transparent p-3" onClick={onExchange}><span className="flex items-center gap-3"><OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" priority={true} rounded="" imageClassName="object-contain" src="/assets/onramp/method-exchange.png" alt="" size="size-10" className="bg-transparent" /><span className="flex flex-col items-start"><span className="text-body font-medium">{t("exchange_transfer")}</span><span className="text-caption text-foreground-secondary">{t("exchange_transfer_description")}</span></span></span></AnimatedButton> : null;
    $[13] = exchangeEnabled;
    $[14] = onExchange;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== connectedWalletEnabled || $[18] !== connectedWalletLoading || $[19] !== onConnectedWallet) {
    t8 = walletConfigured && !connectedWalletEnabled ? <WalletMethod kind="wallet" enabled={connectedWalletEnabled} loading={connectedWalletLoading} onSelect={onConnectedWallet} /> : null;
    $[17] = connectedWalletEnabled;
    $[18] = connectedWalletLoading;
    $[19] = onConnectedWallet;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== cryptoDepositEnabled || $[22] !== onCryptoDeposit) {
    t9 = cryptoConfigured && !cryptoDepositEnabled ? <WalletMethod kind="crypto" enabled={cryptoDepositEnabled} onSelect={onCryptoDeposit} /> : null;
    $[21] = cryptoDepositEnabled;
    $[22] = onCryptoDeposit;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <div className="overflow-hidden rounded-control bg-background-tertiary">{t4}{t5}{t6}{t7}{t8}{t9}</div>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
function WalletMethod(t0) {
  const $ = _c(24);
  const {
    kind,
    enabled,
    loading: t1,
    onSelect
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const t = useTranslations("onramp");
  let t2;
  if ($[0] !== kind || $[1] !== t) {
    t2 = kind === "wallet" ? t("connected_wallet_title") : t("crypto_deposit_title");
    $[0] = kind;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const title = t2;
  let t3;
  if ($[3] !== enabled || $[4] !== kind || $[5] !== loading || $[6] !== t) {
    t3 = enabled ? kind === "wallet" ? t("connected_wallet_subtitle") : t("crypto_deposit_subtitle") : loading ? t("checking_methods") : kind === "wallet" ? t("connected_wallet_unavailable") : t("bank_unavailable.provider_unavailable");
    $[3] = enabled;
    $[4] = kind;
    $[5] = loading;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const subtitle = t3;
  const t4 = !enabled;
  const t5 = kind === "wallet" ? "/assets/onramp/method-wallet.png" : "/assets/onramp/method-crypto.png";
  let t6;
  if ($[8] !== t5) {
    t6 = <OptimizedImage nsfw={false} variant="thumbnail" preview={false} loadReveal="none" priority={true} rounded="" imageClassName="object-contain" src={t5} alt="" size="size-10" className="bg-transparent" />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== title) {
    t7 = <span className="text-body font-medium">{title}</span>;
    $[10] = title;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== subtitle) {
    t8 = <span className="text-caption text-foreground-secondary">{subtitle}</span>;
    $[12] = subtitle;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7 || $[15] !== t8) {
    t9 = <span className="flex flex-col items-start">{t7}{t8}</span>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t9) {
    t10 = <span className="flex items-center gap-3">{t6}{t9}</span>;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== onSelect || $[21] !== t10 || $[22] !== t4) {
    t11 = <AnimatedButton variant="tertiary" disabled={t4} suffix={ArrowRight01Icon} className="h-auto min-h-16.5 w-full justify-between bg-transparent p-3" onClick={onSelect}>{t10}</AnimatedButton>;
    $[20] = onSelect;
    $[21] = t10;
    $[22] = t4;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}